import React, { useEffect, useState } from 'react'
import {Box, Grid, GridItem, Heading, Table,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableContainer,
  Text,} from '@chakra-ui/react'
import CustomButton from '../../elements/customButton'
import CustomToast from '../../elements/customToast'
import { connect, useSelector } from 'react-redux'
import Loader from '../../elements/loader'
import { bindActionCreators } from 'redux'
import { ActionCreators } from '../../../redux/actions'
import PaymentDialogRegisterFee from '../PaymentModule/PaymentDialogRegisterFee'

const FeePayment = (props) => {
  const {addToast} = CustomToast()
  const kycState = useSelector((state) => state.kycState)
  const masterState = useSelector((state) => state.masterState)
  const userData = masterState?.getCurrentUserDetails?.data?.data
  const [paymentMethod, setPaymentMethod] = useState(null)
  const [openPaymentModal, setOpenPaymentModal] = useState(false)
  let amount= props?.feeData?.total_fee_amount 
  const [payableAmount, setPayableAmount] = useState(null)
 
  const handleAddFundsDialog = () => {
    if (!props?.feeData?.personal_data) {
      addToast({message: 'Please Complete Personal Details First', status: 'error'})
      return
    }
    if (!props?.feeData?.bank_data) {
      addToast({message: 'Please Complete Bank Details First', status: 'error'})
      return
    }
    if (!props?.feeData?.document_data) {
      addToast({message: 'Please Upload Documents First', status: 'error'})
      return
    }
    console.log("truyee")
    if (!props?.feeData?.personal_data) {
      addToast({message: 'Please Complete Personal Details First', status: 'error'})
      return
    }
    if (!props?.feeData?.bank_data) {
      addToast({message: 'Please Complete Bank Details First', status: 'error'})
      return
    }
    if (!props?.feeData?.document_data) {
      addToast({message: 'Please Upload Documents First', status: 'error'})
      return
    }
    // setPayableAmount(amount)
    setOpenPaymentModal(true)

}
const handleClosePaymentDialog = () => {
  setPayableAmount(null)
  setOpenPaymentModal(false)
}
  return (
    <>
      {(masterState?.getCurrentUserDetails?.loading || kycState?.generateOrder?.loading || kycState?.getPaymentStatus?.loading
      || kycState?.updateOrderStatus?.loading) &&
      <div>
        <Loader />
      </div>
      }
      <Box className='main_form_container'>
        <Grid className="grid_container">
          <GridItem>
            <Heading as="h1" className="font-poppins text_heading">Fee Payment</Heading>
            <Heading as="h1" className="font-poppins text_subheading">To verify your details and to perform a credit underwriting, we charge a nominal registration amount. Please make this payment in order to proceed further and finish your registration process.</Heading>
            <Box mb={7} className='form_kyc'>
              <Box mt={7} className='table_wrapper'>
                <TableContainer>
                  <Table variant='simple'>
                    <Tbody>
                      <Tr>
                        <Td>Registration Fee
                          {props?.feeData?.registration_fee === 0 &&
                            <span className='save_fee'>Save 100</span>
                          }
                        </Td>
                        <Td>
                          {props?.feeData?.registration_fee === 0 &&
                            <span className='wave_fee'>INR 100</span>
                          }
                          INR {props?.feeData?.registration_fee}</Td>
                      </Tr>
                      <Tr>
                        <Td>SGST (9%)</Td>
                        <Td>INR {props?.feeData?.sgst_fee}</Td>
                      </Tr>
                      <Tr>
                        <Td>CGST (9%)</Td>
                        <Td>INR {props?.feeData?.cgst_fee}</Td>
                      </Tr>
                    </Tbody>
                    <Tfoot>
                      <Tr>
                        <Th>Total Amount to be paid</Th>
                        <Th>INR {props?.feeData?.total_fee_amount}</Th>
                      </Tr>
                    </Tfoot>
                  </Table>
                </TableContainer>
              </Box>
              {props?.feeData?.registration_fee === 0 &&
                <Text className="fee_note font-poppins">Congratulations! Your KYC fee has been waived.</Text>
              }
            </Box>
          </GridItem>
        </Grid>
        {props?.feeData?.registration_fee === 0 ?
            <Box className="kyc_actions">
              <CustomButton size="md" type="submit" title={'Pay Now ₹ ' + props?.feeData?.total_fee_amount} className="btn_green font-poppins" isDisabled={true} />
            </Box>
          :
          <Box className="kyc_actions">
            {props?.feeData?.registration_fee_status === 1 ?
              <CustomButton size="md" type="submit" title={'Paid ₹ ' + props?.feeData?.total_fee_amount} className="btn_green font-poppins" isDisabled={true} /> :
              <CustomButton size="md" type="submit" title={'Pay Now ₹ ' + props?.feeData?.total_fee_amount} className="btn_green font-poppins" onClick={()=>handleAddFundsDialog()} />
            }
          </Box>
        }
            <PaymentDialogRegisterFee openPayModal={openPaymentModal}  userData ={userData}  handleClosePaymentDialog={handleClosePaymentDialog}
           payableAmount={amount}
           />
      </Box>
    </>
  )
}
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(ActionCreators, dispatch),
})

export default connect(null, mapDispatchToProps)(FeePayment)